import React from "react";
import { Outlet } from "react-router-dom";

/*
  Component to manage the entire STATIC PAGES section
*/
function StaticPages() {
  return <Outlet />;
}

export default StaticPages;
